import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { companyInfo, awards } from '../data/mockData';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-100 via-blue-50 to-blue-200">
        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-orange-300/40 to-transparent rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" />
        <div className="absolute top-1/2 right-0 w-80 h-80 bg-gradient-to-bl from-blue-300/30 to-transparent rounded-full blur-3xl transform translate-x-1/2" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        {/* Awards Badges */}
        <div className="flex flex-wrap gap-2 mb-8">
          {awards.map((award) => (
            <div
              key={award.id}
              className="bg-orange-500 text-white text-xs font-semibold px-3 py-1.5 rounded-md shadow-md"
            >
              <div className="flex items-center space-x-1">
                <span className="text-[10px]">TOP</span>
                <span className="font-bold">WORK</span>
              </div>
              <div className="text-[10px] text-orange-200">PLACES {award.year}</div>
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="max-w-3xl">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-12 h-0.5 bg-orange-500" />
            <span className="text-gray-600 font-medium tracking-wide">Sanisolutions Inc...</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-orange-500 mb-8 leading-tight">
            {companyInfo.tagline.split('. ').map((word, index) => (
              <span key={index}>
                {word}.
                {index < companyInfo.tagline.split('. ').length - 1 && ' '}
              </span>
            ))}
          </h1>

          <p className="text-gray-700 text-lg leading-relaxed mb-10 max-w-2xl">
            {companyInfo.description}
          </p>

          <div className="flex flex-wrap gap-4">
            <Link to="/about">
              <Button
                className="bg-transparent border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white px-8 py-6 text-base font-medium rounded-full transition-all duration-300"
              >
                Know more
              </Button>
            </Link>
            <Link to="/capabilities">
              <Button
                className="bg-transparent border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white px-8 py-6 text-base font-medium rounded-full transition-all duration-300"
              >
                Capabilities
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
